export default "__VITE_ASSET__d0e6dd55__"